// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3op5H","additionalInfo":"AgreementModal_additionalInfo__2TTv6"};